<template>
  <div class="page plr16">
    <div class="ptb16">
      <p style="font-weight: bold;"><span class="moneys fontSize14">(今日数据将在次日0点更新)</span></p>
    </div>
    <div class="mains-content">
      <div class="member-content-box br10">
        <div class="boxs br10">
          <p class="titles"><v-date @time="change" :clearable="false"></v-date></p>
          <el-button type="primary" v-show="query.queryType == 'shop'"
            v-perm="{ key: 'saleTarget', value: 'saleTarget:configShop' }" @click="shopSarget">配置门店业绩目标</el-button>
          <el-button type="primary" v-show="query.queryType == 'staff'"
            v-perm="{ key: 'saleTarget', value: 'saleTarget:configStaff' }" @click="staffSarget">配置店员业绩目标</el-button>
        </div>
        <el-tabs class="tabs" v-model="query.queryType" type="card" @tab-click="tableChange"
          v-perm="{ key: 'saleTarget', value: 'saleTarget:list' }">
          <el-tab-pane label="门店业绩目标" name="shop">
            <div class="tables">
              <el-table :data="shopList" max-height="370px" header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="name" label="指标"></el-table-column>
                <el-table-column prop="amount" label="目标"></el-table-column>
                <el-table-column prop="completeProductAchAmount" label="已完成">
                  <template slot-scope="scope">
                    <div
                      :class='[scope.row.statusCn == "未达标" ? "reach" : scope.row.statusCn == "超额完成" ? "notQualified" : ""]'>
                      {{ scope.row.completeTotal }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="completenessAmount" label="完成度"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="店员业绩目标" name="staff" class="el-table-class">
            <el-table :data="list" :row-class-name="tableRowClassName" :max-height="height - 300"
              header-cell-class-name="table_header_bgcolor" v-if="query.queryType == 'staff'">
              <el-table-column prop="staffName" label="姓名" align="center"></el-table-column>
              <el-table-column prop="completeness" label="总完成度" align="center"></el-table-column>
              <el-table-column prop="completeShopAchAmount" label="门店业绩" align="center"></el-table-column>
              <el-table-column prop="completeProductAchAmount" label="产品业绩" align="center"></el-table-column>
              <el-table-column prop="completeRepairAchAmount" label="修护业绩" align="center"></el-table-column>
              <el-table-column prop="otherServeAchAmountComplete" label="其他业绩" align="center"></el-table-column>
              <el-table-column prop="rechargeTargetAmountComplete" label="充值目标" align="center"></el-table-column>
              <el-table-column prop="commissionTargetAmountComplete" label="提成目标" align="center"></el-table-column>
              <el-table-column prop="completeFootTotal" label="泡脚个数" align="center"></el-table-column>
              <el-table-column prop="completeMemberTotal" label="新增会员数" align="center"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

      </div>
      <div class="title-box fb fontSize18" v-if="query.queryType == 'shop'"><span class="blueBlock"></span>总完成度：{{
        form.completeness }}</div>
      <div class="white br10" v-if="query.queryType == 'shop'">
        <div class="title-box">
          <p><span class="blueBlock"></span>业绩目标变更审核记录</p>
        </div>
        <div class="plrb16">
          <el-table :data="liData" max-height="196px" header-cell-class-name="table_header_bgcolor">
            <el-table-column prop="oxCtime" label="申请时间">
              <template slot-scope="scope">
                {{ scope.row.oxCtime ? formatDay(scope.row.oxCtime) : " " }}
              </template>
            </el-table-column>
            <el-table-column prop="dataMonth" label="变更月份">
              <template slot-scope="scope">
                {{ scope.row.dataMonth ? formatMonth(scope.row.dataMonth) : " " }}
              </template>
            </el-table-column>
            <el-table-column prop="auditStatusCn" label="审核状态"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <shop-edit ref="editSetForm" @change="editChange"></shop-edit>
    <staff-edit ref="staffEditForm" @change="editChange"></staff-edit>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import shopEdit from "./shopEdit";
import staffEdit from "./staffEdit";
export default {
  mixins: [minxin],
  data() {
    return {
      list: [],
      joinType: "",
      isSuperManage: null,
      url: this.$url.saleTargetShop.page,
      query: {
        queryType: "shop",
        size: 20,
        start: 1
      },
      form: {},
      liData: [],
      shopList: [],
      height: this.$store.getters.MainHeight,
      flag: true
    };
  },
  components: {
    shopEdit,
    staffEdit
  },
  created() {
    this.isSuperManage = this.$store.getters.ShopInfo.superManage;
  },
  mounted() {
    this.getData();
    this.getAuditList();
  },
  methods: {
    change(value) {
      this.query.shopId = this.$store.getters.ShopIds
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';

      this.getData();
      this.getAuditList();
    },
    getData() {
	  if(this.query.beginTime==undefined ||this.query.beginTime=='')
	  {
		  this.query.beginTime=this.getCurrentDate();
	  }
	  if(this.query.endTime==undefined || this.query.endTime=='')
	  {
			this.query.endTime=this.getCurrentDate();
	  }
      this.$api.post(this.url, this.query).then(res => {
        if (res) {
          if (this.query.queryType == "shop") {
            this.form = res;
            let obj1 = {
              name: '门店业绩',
              amount: res.shopAchAmount,
              completeTotal: res.completeShopAchAmount,
              statusCn: res.shopAchAmountStatus,
              completenessAmount: res.completenessShopAchAmount
            }
            let obj2 = {
              name: '产品销售业绩',
              amount: res.productAchAmount,
              completeTotal: res.completeProductAchAmount,
              statusCn: res.productAchAmountStatus,
              completenessAmount: res.completenessProductAchAmount
            }
            let obj3 = {
              name: '修护业绩',
              amount: res.repairAchAmount,
              completeTotal: res.completeRepairAchAmount,
              statusCn: res.repairAchAmountStatus,
              completenessAmount: res.completenessRepairAchAmount
            }
            let obj4 = {
              name: '其他业绩',
              amount: res.otherServeAchAmount,
              completeTotal: res.otherServeAchAmountComplete,
              statusCn: res.otherServeAchAmountStatus,
              completenessAmount: res.otherServeAchAmountCompleteness
            }
            let obj5 = {
              name: '充值目标',
              amount: res.rechargeTargetAmount,
              completeTotal: res.rechargeTargetAmountComplete,
              statusCn: res.rechargeTargetAmountStatus,
              completenessAmount: res.rechargeTargetAmountCompleteness
            }
            let obj6 = {
              name: '提成目标',
              amount: res.commissionTargetAmount,
              completeTotal: res.commissionTargetAmountComplete,
              statusCn: res.commissionTargetAmountStatus,
              completenessAmount: res.commissionTargetAmountCompleteness
            }
            let obj7 = {
              name: '泡脚个数',
              amount: res.footTotal,
              completeTotal: res.completeFootTotal,
              statusCn: res.footTotalStatus,
              completenessAmount: res.completenessFootTotal
            }
            let obj8 = {
              name: '新增会员数',
              amount: res.memberTotal,
              completeTotal: res.completeMemberTotal,
              statusCn: res.memberTotalStatus,
              completenessAmount: res.completenessMemberTotal
            }
            this.shopList = [obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8]
          } else {
            this.list = res;
          }
        }
      });
    },
    tableChange(val) {
      this.list = [];
      this.query.start = 1;
      this.query.queryType = val.name;

      if (val.name == 'shop') {
        this.url = this.$url.saleTargetShop.page;
        this.getData();
        this.getAuditList();
      } else if (val.name == 'staff') {
        this.url = this.$url.saleTargetStaff.page;
        this.getData();
      }
    },
    tableRowClassName({ row, rowIndex }) {
      let completeness = row.completeness.replace("%", "");
      if (completeness >= 100) {
        return 'success-row'
      } else if (completeness > 0) {
        return 'danger-row'
      }
      return ''
    },
    getAuditList(item) {
      this.$api.get(this.$url.saleTargetShop.audit, { shopId: this.query.shopId, beginTime: this.query.beginTime, endTime: this.query.endTime }).then(res => {
        console.log(res)
        if (res) {
          this.liData = res;

        }
      });
    },
    editChange(org) {
      if (org) {
        this.getData();
      }
    },
    shopSarget(item) {
      this.$refs["editSetForm"].$emit("set", { item: item });
    },
    staffSarget(item) {
      this.$refs["staffEditForm"].$emit("set", { item: item });
    },
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

/deep/ .el-tabs--border-card>.el-tabs__content {
  padding: 0;
}

.mains-content {
  height: 100%;

  .member-content-box {
    background: #fff;
    height: calc(100% - 63px);
  }
}

.targets {
  text-align: center;

  .el-col {
    padding: 5px 0;
  }
}

.tabs {
  padding: 0 16px 16px;
}

.title-box {
  margin-top: 16px;
  background: #fff;
  padding: 20px 0;
  display: flex;
  align-items: center;
  border-radius: 10px;

  .blueBlock {
    display: inline-block;
    width: 4px;
    height: 18px;
    border-radius: 0px 4px 4px 0px;
    background: #3388FF;
    margin-right: 16px;
  }
}

.boxs {
  padding: 16px 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;

  .titles {
    font-size: 16px;
    display: flex;
    align-items: center;
  }
}

.reach {
  color: red !important;
}

.notQualified {
  color: green !important;
}

.center {
  text-align: center;
}

.el-table-class ::v-deep .success-row {
  color: #67c23a !important;
}

.el-table-class ::v-deep .danger-row {
  color: rgba(198, 35, 28) !important;
}
</style>